<template>
  <div id="ddLogin">
    <div class="top_center">
      <img src="/static/img/logo2.png" width="96px" height="106px" />
      <div class="content_title">{{ title }}</div>
      <div class="content_label">连接型CRM，覆盖销售、营销、服务的客户全生命周期数字化、移动化管理</div>
    </div>
    <a-divider style="margin: 50px 0;" />
    <div class="bot">
      <a-button type="primary" loading>自动登录中，请稍后...</a-button>
    </div>
  </div>
</template>

<script>
import myVue from './myData'
import { mapMutations } from 'vuex'
export default {
  name: 'ddLogin',
  mixins: [myVue],
  data () {
    return {
      // eslint-disable-next-line no-undef
      title: isRLZY ? '捷报人力办公平台' : '捷报办公平台',
      urlCode: '',
      publicDictData: {
        returnedMoneyTypeList: [],
        returnedMoneyTypeObj: {},
        paymentMethodList: [],
        paymentMethodObj: {},
        billTypeList: [],
        billTypeObj: {},
        advanceTypeList: [],
        advanceTypeObj: {},
        prepayTypeList: [],
        prepayTypeObj: {},
        costTypeList: [],
        costTypeObj: {},
        comAccountList: [],
        comAccountObj: {},
        subsidiaryList: [],
        subsidiaryObj: {},
        receiptsTypeList: [],
        receiptsTypeObj: {},
        contractSubTypeList: [],
        contractSubTypeObj: {},
        customerTypeList: [],
        customerTypeObj: {},
        dimissionTypeList: [],
        dimissionTypeObj: {},
        resignationsLinkNameTypeList: [],
        resignationsLinkNameTypeObj: {},
        supplierTypeList: [],
        supplierTypeObj: {},
        projectPhaseList: [],
        projectPhaseObj: {},
        projectStatusList: [],
        projectTypeList: [],
        signExpectationList: [],
        linkNameTypeList: [],
        linkNameTypeObj: {},
        paymentTypeList: [],
        paymentTypeObj: {},
        noticeTypeList: [],
        noticeTypeObj: {},
        projectPersonList: [],
        projectPersonObj: {},
        cgTypeList: [],
        cgTypeObj: {},
        extraPayTypeList: [],
        extraPayTypeObj: {},
        workOutTypeList: [],
        workOutTypeObj: {},
        overtimeTypeList: [],
        overtimeTypeObj: {},
        returnedMoneyMethodsList: [],
        returnedMoneyMethodsObj: {},
        feesChargesTypeList: [],
        feesChargesTypeObj: {},
        personnelCostTypeList: [],
        personnelCostTypeObj: {},
        checkStatusList: [],
        checkStatusObj: {},
        fundCostTypeList: [],
        fundCostTypeObj: {},
        storageLocationList: [],
        storageLocationObj: {},
        outcarObj: {},
        outcarList: [],
        unitList: [],
        unitObj: {}
      }
    }
  },
  created () {
    this.$db.clear()
    this.$router.options.routes = []
  },
  mounted () {
    let url = window.location.search
    this.urlCode = url.split('=')[2]
    /* url有code代表是浏览器访问,回调code后进行请求
    若是没有code则代表钉钉应用内直接进入-免登流程 */
    if (this.urlCode) {
      this.getToken()
    } else {
      this.getDingCode()
    }
  },
  methods: {
    getToken () {
      this.$get('/auth', { authCode: this.urlCode }).then(res => {
        if (res) {
          const data = res.data.data
          // 存取登录方式 1浏览器 2钉钉
          this.$db.save('USER_TYPE', 2)
          window.parent.flag(data)
          // this.saveLoginData(data)
        }
      })
    },
    getDingCode () {
      this.getCode(code => {
        this.$get('/ding/login', { code: code }).then(res => {
          if (res.data.status === 1) {
            const data = res.data.data
            this.$db.save('USER_TYPE', 2)
            this.saveLoginData(data)
            // 存储缓存
            this.getDictData()
          } else {
            this.$message.warning(res.data.message)
          }
        })
      })
    },
    getPf () {
      if (Object.keys(this.$route.query).length > 0) {
        // 请求对应数据
        const { recordId, id, checkType, isBack, callbackUrl, status } = this.$route.query
        if (callbackUrl) {
          this.$router.push(callbackUrl)
        } else {
          this.$router.push({ path: '/approvalManage/approvalData', query: { recordId, id, checkType, isBack, status } })
        }
      } else {
        this.$router.push('/home')
      }
    },
    getDictData () {
      // 循环存取字典数据
      Promise.all([
        this.setPublicDictData('purchase_type', 'cgTypeList', 'cgTypeObj'), // 采购分类
        this.setPublicDictData('purchase_costType', 'extraPayTypeList', 'extraPayTypeObj'), // 采购附加费用分类
        this.setPublicDictData('returnedMoney_type', 'returnedMoneyTypeList', 'returnedMoneyTypeObj'), // 回款类别
        this.setPublicDictData('returnedMoney_paymentMethod', 'paymentMethodList', 'paymentMethodObj'), // 付款方式
        this.setPublicDictData('purchase_paymentType', 'paymentTypeList', 'paymentTypeObj'), // 付款记录分类
        this.setPublicDictData('office_noticeType', 'noticeTypeList', 'noticeTypeObj'), // 内部公告分类
        this.setPublicDictData('billingRecord_billType', 'billTypeList', 'billTypeObj'), // 票据类型
        this.setPublicDictData('finance_advanceType', 'advanceTypeList', 'advanceTypeObj'), // 预支类型
        this.setPublicDictData('finance_prepayType', 'prepayTypeList', 'prepayTypeObj'), // 预付类型
        this.setPublicDictData('finance_costType', 'costTypeList', 'costTypeObj'), // 费用报销类别
        this.setPublicDictData('returnedMoney_comAccount', 'comAccountList', 'comAccountObj'), // 公司账户
        this.setPublicDictData('contract_type', 'receiptsTypeList', 'receiptsTypeObj'), // 合同分类
        this.setPublicDictData('contract_subType', 'contractSubTypeList', 'contractSubTypeObj'), // 合同类型细分
        this.setPublicDictData('client_type', 'customerTypeList', 'customerTypeObj'), // 客户种类
        this.setPublicDictData('client_resignationsCompensation', 'dimissionTypeList', 'dimissionTypeObj'), // 离职补偿人员种类
        this.setPublicDictData('client_resignationsLinkName', 'resignationsLinkNameTypeList', 'resignationsLinkNameTypeObj'), // 离职补偿人员联系人分类类
        this.setPublicDictData('client_supplierType', 'supplierTypeList', 'supplierTypeObj'), // 供应商类型
        this.setPublicDictData('project_stage', 'projectPhaseList', 'projectPhaseObj'), // 项目阶段
        this.setPublicDictData('project_type', 'projectTypeList'), // 项目类型
        this.setPublicDictData('project_status', 'projectStatusList'), // 项目状态
        this.setPublicDictData('project_subsidiary', 'subsidiaryList', 'subsidiaryObj'), // 下属公司 2695
        this.setPublicDictData('project_signExpectation', 'signExpectationList'), // 签单预期
        this.setPublicDictData('linkman_type', 'linkNameTypeList', 'linkNameTypeObj'), // 联系人类型
        this.setPublicDictData('expenseReim_projectPerson', 'projectPersonList', 'projectPersonObj'), // 项目负责人-费用报销新建
        this.setPublicDictData('workOutType', 'workOutTypeList', 'workOutTypeObj'), // 外出类型
        this.setPublicDictData('outcar', 'outcarList', 'outcarObj'), // 外出类型
        this.setPublicDictData('overtimeType', 'overtimeTypeList', 'overtimeTypeObj'), // 加班
        this.setPublicDictData('feesChargesType', 'feesChargesTypeList', 'feesChargesTypeObj'), // 经营成本-费用类别
        this.setPublicDictData('returnedMoney_Methods', 'returnedMoneyMethodsList', 'returnedMoneyMethodsObj'), // 回款方式
        this.setPublicDictData('personnelCost_type', 'personnelCostTypeList', 'personnelCostTypeObj'), // 人员成本类型
        this.setPublicDictData('checkStatus', 'checkStatusList', 'checkStatusObj'), // 审核状态
        this.setPublicDictData('fundCostType', 'fundCostTypeList', 'fundCostTypeObj'), // 项目资金管理方式
        this.setPublicDictData('storageLocation', 'storageLocationList', 'storageLocationObj'), // 存放地点
        this.setPublicDictData('unit', 'unitList', 'unitObj') // 单位
      ]).catch(e => {
        this.$message.warning(e)
      }).finally(r => {
        // 存取到vuex
        this.setDictData(this.publicDictData)
        // 跳转
        this.getPf()
      })
    },
    setPublicDictData (dictNameEn, dictList, dictObj) {
      return new Promise((resolve, reject) => {
        this.$get('/common/dict/getListByEn', { dictTypeEn: dictNameEn }).then(res => {
          if (res.data.status === 1) {
            let resData = res.data.data
            resData.forEach(item => {
              this.publicDictData[dictList].push({
                label: item.dictCode,
                value: item.dictName,
                parentEn: dictNameEn,
                listVal: dictList,
                objVal: dictObj
              })
            })
            if (dictObj) {
              resData.forEach(item => {
                this.publicDictData[dictObj][item.dictCode] = item.dictName
              })
            }
            resolve(this.publicDictData)
          } else {
            reject(res.data.msg)
          }
        })
      })
    },
    ...mapMutations({
      setPurchaseDictData: 'account/setPurchaseDictData',
      setDictData: 'account/setDictData'
    })
  }
}
</script>

<style type="less" scoped>
#ddLogin {
  text-align: center;
}
.top_center {
  padding-top: 120px;
}
.content_title {
  margin-top: 4px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 2px;
}
.content_label {
  margin-top: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/ddLogin/index.vue